// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

let ContractChangeDetailsController = function ($scope, $routeParams, $q, $window, ContractChange, Plan, Component, Discount, PlanVariant) {
    
    $scope.loadedNamesOfPlansById = {};
    $scope.loadedNamesOfPlanVariantsById = {};
    $scope.loadedNamesOfComponentById = {};
    $scope.loadedNamesOfDiscountById = {};
    $scope.isDataLoaded = false;
    
    $scope.loadContractChangeDetails = function () {
        ContractChange.getContractChangeById($routeParams.id, { includeContract: true, includeComponentSubscriptions: 'All', includeDiscountSubscriptions: 'All', includePauses: 'All'})
            .then(function(response){ $scope.contractChange = response.data })
            .then(function() { return $scope.loadPlanNames($scope.contractChange) })
            .then(function() { return $scope.loadPlanVariantNames($scope.contractChange) })
            .then(function() { return $scope.loadComponentNames($scope.contractChange) })
            .then(function() { return $scope.loadDiscountNames($scope.contractChange) })
            .then(function() {
                $scope.phases = zip($scope.contractChange.Contract.After.Phases, $scope.contractChange.Contract?.Before?.Phases)
            })
            .then(function() { $scope.isDataLoaded = true });
        };

    function zip(a, b) { 
        if (!a) a = [];
        if (!b) b = [];
        
        return Array.from(Array(Math.max(b.length, a.length)), function (_, i)  { return {after: a[i], before: b[i]}; })
    }
    
    function onlyUnique(value, index, self) { return value && self.indexOf(value) === index; }
    
    $scope.loadPlanNames = function (contractChange){
        let contract = contractChange.Contract;
        let afterPhases = contract.After.Phases;
        let beforePhases = contract?.Before?.Phases;
        if (!beforePhases) beforePhases = [];
        
        let planIdsAvailable = afterPhases.concat(beforePhases).map(function(phase) { return phase.PlanId }).filter(onlyUnique);

        let promises = [];
        planIdsAvailable.forEach(function (id) {
            promises.push($scope.getPlanName(id));
        });
        
        return $q.all(promises);
    }

    $scope.loadPlanVariantNames = function (contractChange){
        let contract = contractChange.Contract;
        let afterPhases = contract.After.Phases;
        let beforePhases = contract?.Before?.Phases;
        if (!beforePhases) beforePhases = [];

        let planaVariantIdsAvailable = afterPhases.concat(beforePhases).map(function(phase) { return phase.PlanVariantId }).filter(onlyUnique);

        let promises = [];
        planaVariantIdsAvailable.forEach(function (id) {
            promises.push($scope.getPlanVariantName(id));
        });

        return $q.all(promises);
    }
    
    $scope.loadComponentNames = function (contractChange) {
        let componentIds = contractChange.ComponentSubscriptions.map(function(subscription) { return [subscription?.After?.ComponentId, subscription?.Before?.ComponentId] });
        componentIds = Array.prototype.concat.apply([], componentIds).filter(onlyUnique);

        let promises = [];
        componentIds.forEach(function (id) {
            promises.push($scope.getComponentName(id));
        });

        return $q.all(promises);
    }
    
    $scope.loadDiscountNames = function (contractChange){
        let discountIds = contractChange.DiscountSubscriptions.map(function(subscription) { return [subscription?.After?.DiscountId, subscription?.Before?.DiscountId] });
        discountIds = Array.prototype.concat.apply([], discountIds).filter(onlyUnique);

        let promises = [];
        discountIds.forEach(function (id) {
            promises.push($scope.getDiscountName(id));
        });

        return $q.all(promises);
    };

    $scope.getComponentName = function (componentId){
        if (!componentId)
            return $q.resolve(null);

        let existingValue = $scope.loadedNamesOfComponentById[componentId];
        if (existingValue != null)
            return $q.resolve(existingValue);

        return Component.get({ componentId: componentId }, function () {}).$promise.then(function(response){
            $scope.loadedNamesOfComponentById[componentId] = response.Name._c;
        });
    }

    $scope.getDiscountName = function (discountId){
        if (!discountId)
            return $q.resolve(null);

        let existingValue = $scope.loadedNamesOfDiscountById[discountId];
        if (existingValue != null)
            return $q.resolve(existingValue);

        return Discount.get({ discountId: discountId }, function () {}).$promise.then(function(response){
            $scope.loadedNamesOfDiscountById[discountId] = response.InternalName;
        });
    }
    
    $scope.getPlanName = function (planId){
        if (!planId)
            return $q.resolve(null);
        
        let existingValue = $scope.loadedNamesOfPlansById[planId];
        if (existingValue != null)
            return $q.resolve(existingValue);
        
        return Plan.get({ planId: planId }, function () {}).$promise.then(function(response){
            $scope.loadedNamesOfPlansById[planId] = response.Name._c;
        });
    }

    $scope.getPlanVariantName = function (planVariantId){
        if (!planVariantId)
            return $q.resolve(null);

        let existingValue = $scope.loadedNamesOfPlanVariantsById[planVariantId];
        if (existingValue != null)
            return $q.resolve(existingValue);

        return PlanVariant.get({ id: planVariantId }, function () {}).$promise.then(function(response){
            $scope.loadedNamesOfPlanVariantsById[planVariantId] = response.InternalName;
        });
    }

    $scope.back = function () {
        $window.history.back();
    }

    $scope.loadContractChangeDetails();
}

ContractChangeDetailsController.$inject = ['$scope', '$routeParams', '$q', '$window', 'ContractChange', 'Plan', 'Component', 'Discount', 'PlanVariant'];
